"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressForm = void 0;
var useAddressForm_1 = require("./useAddressForm");
Object.defineProperty(exports, "useAddressForm", { enumerable: true, get: function () { return useAddressForm_1.useAddressForm; } });
//# sourceMappingURL=index.js.map